import { EnvironmentProviders, importProvidersFrom, Provider } from "@angular/core";
import {
  ConnectionHttpService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SoftlineEntityService,
  StoreModule
} from "@softline/core";

import { provideModuleWidgets, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import { SOFTLINE_API_WORK_NOTES } from "../arbeitsschein.api";
import {
  SOFTLINE_FEATURE_WORK_NOTE_WIDGET,
  SOFTLINE_PERMISSION_WORK_NOTE,
  WorkNoteCollectionStore
} from "../arbeitsschein.shared";

export const arbeitsscheinWidgetProviders: (Provider | EnvironmentProviders)[] = [
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_WORK_NOTE_WIDGET,
      feature: WorkNoteCollectionStore.feature,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: (service: ConnectionHttpService) =>
            new SoftlineEntityService(service, SOFTLINE_API_WORK_NOTES),
          deps: [SOFTLINE_SERVICE_HTTP],
        }
      ],
    }),
  ),
  ...provideModuleWidgets([
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'gewerbe',
      loadComponent: () =>
        import("./arbeitsschein/arbeitsschein.widget").then(
          (m) => m.ArbeitsscheinWidget
        ),
      permission: SOFTLINE_PERMISSION_WORK_NOTE,
    },
  ]),
];
